export const iframemodulesSchema = {
    type: 'object',
    properties: {
        calendar: {
            type: 'object',
            properties: {
                host: { type: 'string' },
            },
        },
        consultation: {
            type: 'object',
            properties: {
                host: { type: 'string' },
            },
        },
        servicestate: {
            type: 'object',
            properties: {
                host: { type: 'string' },
            },
        },
        'consultation-admin': {
            type: 'object',
            properties: {
                host: { type: 'string' },
            },
        },
        'sdp-parking': {
            type: 'object',
            properties: {
                host: { type: 'string' },
            },
        },
    },
    required: ['calendar', 'consultation', 'servicestate', 'consultation-admin', 'sdp-parking'],
};
